import { format } from 'date-fns';
import { MealCreditInfoTextProps } from 'src/components/oneCorp/features/MealCredit/utils/constructMealCreditInfoText.utils';
import { TimeIntervalTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';

export function formatTimeIntervalForAvailabilityInfo(
  props: Pick<
    MealCreditInfoTextProps,
    'startDate' | 'endTimeFullDate' | 'timeIntervalType'
  >
): string {
  const { startDate, endTimeFullDate, timeIntervalType } = props;

  if (timeIntervalType === TimeIntervalTypeValues.ALL_DAY) {
    return 'any time of the day (local time)';
  }

  const startTime = format(startDate, 'h:mm a');
  const endTime = format(endTimeFullDate, 'h:mm a');

  const isOvernight = timeIntervalType === TimeIntervalTypeValues.OVERNIGHT;
  const overnightText = isOvernight ? ' of the next day' : '';
  return `between ${startTime} and ${endTime}${overnightText} (local time)`;
}
